"use client";

import * as RadioGroupPrimitive from "@radix-ui/react-radio-group";
import type { VariantProps } from "class-variance-authority";
import { type ComponentProps, useMemo } from "react";

import { cn } from "../../utils/cn.util";
import { RadioGroupRootContext } from "./context";
import { type itemStyles, rootStyles } from "./style";

type RadixIgnoredProps = "color" | "highContrast" | "variant" | "size" | "orientation";

export interface RadioGroupRootProps
  extends
    Omit<ComponentProps<typeof RadioGroupPrimitive.Root>, RadixIgnoredProps>,
    VariantProps<typeof itemStyles>,
    VariantProps<typeof rootStyles> {}

export const Root = ({ ref, className, size, color, orientation, ...props }: RadioGroupRootProps) => {
  const providerValue = useMemo(
    () => ({
      size,
      disabled: props.disabled,
    }),
    [size, props.disabled]
  );

  return (
    <RadioGroupRootContext value={providerValue}>
      <RadioGroupPrimitive.Root className={cn(rootStyles({ orientation }), className)} {...props} ref={ref} />
    </RadioGroupRootContext>
  );
};

Root.displayName = RadioGroupPrimitive.Root.displayName;
